import { Modal, Button, Upload, message, Tag } from "antd";
import { InboxOutlined, PaperClipOutlined } from "@ant-design/icons";
import { IoCodeSlash } from "react-icons/io5";
import type { UploadProps } from "antd";
import { useState } from 'react';

interface AllUploadModalProps {
    icon: typeof IoCodeSlash;
    setFile: React.Dispatch<React.SetStateAction<Blob | undefined>>;
    isShowing: boolean;
    toggle: () => void;
    action: (() => void) | (() => Promise<void>);
}

const { Dragger } = Upload;

export function AllUploadModal({ icon: Icon, setFile, isShowing, toggle, action }: AllUploadModalProps) {

    const [fileInfo, setFileInfo] = useState<{name: string, size: string} | null>(null);

    const props: UploadProps = {
        name: 'file',
        multiple: false,
        showUploadList: false,
        beforeUpload: (file) => {
            setFile(file);
            setFileInfo({
                name:file.name,
                size: `${(file.size / 1024 / 1024).toFixed(2)} MB`
            });
            return false;
        },
    };

    const handleRemoveFile = () => {
        setFile(undefined);
        setFileInfo(null);
    };

    return (
        <Modal
            title={
                <div style={{ textAlign: 'left' }}>
                    <h3 style={{ marginTop: '4px', fontWeight: 600, fontSize: '20px', }}>Upload de Excel</h3>
                    <p style={{ textAlign: 'left', fontWeight: 'normal', marginTop: '8px', color: '#D48806', fontSize: '16px' }}>Certifique-se de usar a planilha mais recente</p>
                </div>
            }
            open={isShowing}
            onCancel={() => {
                handleRemoveFile();
                toggle();
            }}
            footer={null}
            centered
            width={600}
        >
            <Dragger {...props}>
                <p className="ant-upload-drag-icon">
                    <InboxOutlined style={{ fontSize: '48px', color: '#0000A4' }} />
                </p>
                <p className="ant-upload-text">Clique ou arraste o arquivo para esta área para fazer upload</p>
                <p className="antd-upload-hint" style={{ color: 'gray' }}>Suporte para upload único ou em massa.</p>
            </Dragger>
            {fileInfo && (
                <div style={{
                    marginTop: '16px',
                    padding: '12px',
                    border: '1px dashed #d9d9d9',
                    borderRadius: '6px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <PaperClipOutlined style={{marginRight: '8px', color: '#0000A4'}} />
                        <span>
                            <div style={{ fontWeight: 500 }}> {fileInfo.name}</div>
                            <div style={{ fontSize: '12px', color: '#8c8c8c'}}>{fileInfo.size}</div>
                        </span>
                    </div>
                    <Button type="text" danger size="small" onClick={handleRemoveFile}>
                        Remover
                    </Button>
                </div>
            )}
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '24px', gap: '8px' }}>
                <Button
                    onClick={toggle}
                    style={{ borderRadius: '6px', width: '100%' }}
                >
                    Cancelar
                </Button>
                <Button
                    type="primary"
                    onClick={action}
                    disabled={!fileInfo}
                    style={{ borderRadius: '6px', width: '100%' }}
                >
                    Enviar
                </Button>
            </div>
        </Modal>
    )
}